import styled from '@emotion/styled';

export const TimeSelectorContainer = styled.div`
    display: flex;
    align-items: stretch;
`;

export const TimeSelectorField = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #B2B2B2;
    min-width: 100px;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;

    ${(props) => props.position === 'left' ? `
        border-radius: 8px 0 0 8px;
        border-right: none;
    ` : `
        border-radius: 0 8px 8px 0;
    `}

    ${(props) => props.isActive && `
        border-color: var(--brand-color, #005DAD);
        background: #F5F5F5;
    `}
`;

export const TimeSelectorLabel = styled.span`
    display: block;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 2px;
    pointer-events: none;
    transition: color 0.2s ease;
    color: ${(props) => props.isActive ? 'var(--brand-color, #005DAD)' : 'var(--grey-600, #6B7280)'};
`;

export const TimeSelectorSelect = styled.select`
    appearance: none;
    -webkit-appearance: none;
    background: transparent;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: var(--grey-800, #272727);
    cursor: pointer;
    width: 100%;
    padding-right: 24px;
`;

export const TimeSelectorIcon = styled.span`
    position: absolute;
    right: 12px;
    bottom: 10px;
    display: flex;
    align-items: center;
    pointer-events: none;
    color: var(--grey-600, #6B7280);
`;
